import ExploreMixin from '@/mixins/ExploreMixin'

export default {
  name: 'Tickets',
  template: '#tickets-template',
  data () {
    return {
      modalActive: false
    }
  },
  mixins: [ExploreMixin],
  computed: {
    ticketChoice () {
      return this.$store.state.ticketChoice
    },
    isFree () {
      return this.$store.state.ticketChoice === 0
    }
  },
  methods: {
    highlightChoice () {
      let choices = Array.from(document.getElementsByClassName('choice'))
      choices.map(choice => {
        choice.classList.remove('selected')
        if (parseInt(choice.dataset.value) === this.ticketChoice) {
          choice.classList.add('selected')
        }
      })
    },
    openModal () {
      this.modalActive = true
      if (this.ticketChoice === 0) {
        this.trackEvent('Team Up (Ticket Entry)', 'Team Up (Ticket Entry): Button: Clash Orb')
      } else {
        this.trackEvent('Team Up (Ticket Entry)', 'Team Up (Ticket Entry): Button: Clash Capsule')
      }
    },
    selectTicket (event) {
      let value = parseInt(event.currentTarget.dataset.value)
      this.$store.dispatch('setTicketChoice', value)
      if (value === 0) {
        this.trackEvent('Team Up (Ticket Entry)', 'Team Up (Ticket Entry): Toggle: Basic Ticket')
      } else {
        this.trackEvent('Team Up (Ticket Entry)', 'Team Up (Ticket Entry): Toggle: Premium Ticket')
      }
      this.highlightChoice()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/assemble/Tickets.js